import {BlockEmbed} from 'quill/blots/block';

class ReadMore extends BlockEmbed {}

ReadMore.tagName = "hr";
ReadMore.blotName = "readMore";
ReadMore.className = "readMore";

export { ReadMore }
